import { render } from "./MedicareCoverage.vue?vue&type=template&id=424eea84&scoped=true"
import script from "./MedicareCoverage.vue?vue&type=script&lang=js"
export * from "./MedicareCoverage.vue?vue&type=script&lang=js"

import "./MedicareCoverage.vue?vue&type=style&index=0&id=424eea84&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-424eea84"]])

export default __exports__